import { useState } from "react";
import { Modal, DatePicker } from "antd";
import dayjs from "dayjs";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Right-sidebar shortcut into the exact same termination flow the Site Status field already
 * drives inline (siteDetail.page.jsx's initiateTermination) - just asks for the Contract End Date
 * up front instead of making someone find the Site Status dropdown and change it by hand first.
 * Submitting doesn't save anything itself - it stages sitestatus/contractenddate the same way the
 * inline edit would and opens the same siteTerminationCheckModal.jsx gate (rota/schedules/mobile
 * service/keys) before anything is actually persisted.
 */
export const TerminateSiteModal = ({ open, onCancel, onConfirm }) => {
    const [contractEndDate, setContractEndDate] = useState(null);

    const handleConfirm = () => {
        if (!contractEndDate) return;
        onConfirm(contractEndDate.format("YYYY-MM-DD"));
        setContractEndDate(null);
    };

    return (
        <Modal
            open={open}
            width="min(440px, 92vw)"
            style={{ top: 10 }}
            closable={false}
            footer={
                <div className="drawer-footer" style={{ justifyContent: "flex-end" }}>
                    <button className="drawer-outlined-btn" onClick={() => { setContractEndDate(null); onCancel(); }}>Cancel</button>
                    <button
                        className={contractEndDate ? "drawer-filled-btn" : "disabled-btn drawer-filled-btn"}
                        disabled={!contractEndDate}
                        onClick={handleConfirm}
                    >
                        Continue
                    </button>
                </div>
            }
        >
            <div className="modal-header-title">
                <span>Terminate Site</span>
                <span onClick={onCancel}><FontAwesomeIcon className="close" icon={faClose}/></span>
            </div>

            <div className="modal-body" style={{ color: "#1e2d3d", fontWeight: 400 }}>
                <p style={{ fontSize: 13, color: "#595959", marginTop: 0 }}>
                    Site Status will be set to Terminated. What's the Contract End Date?
                </p>
                <label>Contract End Date</label>
                <DatePicker
                    style={{ width: "100%" }}
                    format="DD/MM/YYYY"
                    className="generic-input-control"
                    value={contractEndDate}
                    onChange={(date) => setContractEndDate(date)}
                />
            </div>
        </Modal>
    );
};
